<template>
  <v-card>
    <Loader
      v-if="loading"
      :key="generateUniqueId()"
      :loader-state="loading"
    ></Loader>

    <v-card-title class="float-left">
      Création d'une page hébergement
    </v-card-title>

    <LocalSwitcher
      @updateCurrentLocale="updateCurrentLocale($event)"
    ></LocalSwitcher>

    <v-card-text>
      <v-form
        v-model="valid"
        class="multi-col-validation mt-5"
        @submit.prevent="checkForm"
      >
        <p v-if="errors.length">
          <v-alert
            v-for="(error, index) in errors"
            :key="index"
            text
            dense
            type="error"
          >
            {{ error.title }}
          </v-alert>
        </p>

        <Snackbar
          v-if="successMessage"
          :key="generateUniqueId()"
          :snackbar-state="snackbar"
          :success-message="successMessage"
        ></Snackbar>

        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <v-tabs
              grow
            >
              <v-tab>
                <v-icon left>
                  {{ icons.mdiPencil }}
                </v-icon>
                CMS
              </v-tab>
              <v-tab>
                <v-icon left>
                  {{ icons.mdiCameraOutline }}
                </v-icon>
                Images
              </v-tab>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col
                        cols="6"
                        md="6"
                      >
                        <h4>Description de la page hébergement</h4>
                        <br>
                        <v-text-field
                          v-model="name[currentLocale]"
                          label="Nom"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Nom"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="slug[currentLocale]"
                          label="Slug"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Slug"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="title[currentLocale]"
                          label="Titre"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Titre"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="entityData.position"
                          label="Position"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Position"
                          hide-details
                        ></v-text-field>

                        <v-switch
                          v-model="entityData.enabled"
                          :label="'Etat : ' + (entityData.enabled === true ? 'Activé' : 'Désactivé')"
                        ></v-switch>

                        <v-switch
                          v-model="entityData.inMenu"
                          :label="'Dans le menu : ' + (entityData.inMenu === true ? 'Oui' : 'Non')"
                        ></v-switch>

                        <h4>SEO</h4>
                        <br>

                        <v-text-field
                          v-model="seoTitle[currentLocale]"
                          label="Titre SEO"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Titre SEO"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="seoDescription[currentLocale]"
                          label="Description SEO"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Description SEO"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>

                        <v-text-field
                          v-model="seoKeywords[currentLocale]"
                          label="Mot clés"
                          class="mb-5"
                          outlined
                          dense
                          placeholder="Mot clés"
                          hide-details
                        >
                          <template v-slot:append>
                            <country-flag
                              class="inner-input-flag"
                              :country="currentLocale === 'en' ? 'gb' : currentLocale"
                              size="normal"
                              shadow
                            />
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col
                        cols="6"
                        md="6"
                      >
                        <div class="content-ckeditor-region">
                          <h4>Description</h4>
                          <br>
                          <ckeditor
                            v-model="description[currentLocale]"
                            :editor="editor"
                            :config="editorConfig"
                            height="10"
                            row="50"
                          />
                          <country-flag
                            class="inner-input-flag content-flag-placeholder"
                            :country="currentLocale === 'en' ? 'gb' : currentLocale"
                            size="normal"
                            shadow
                          />
                        </div>

                        <br>

                        <div class="content-ckeditor-region">
                          <h4>Description bas de page</h4>
                          <br>
                          <ckeditor
                            v-model="bottomDescription[currentLocale]"
                            :editor="editor"
                            :config="editorConfig"
                            height="10"
                            row="50"
                          />
                          <country-flag
                            class="inner-input-flag content-flag-placeholder"
                            :country="currentLocale === 'en' ? 'gb' : currentLocale"
                            size="normal"
                            shadow
                          />
                        </div>

                        <br>

                        <h4>Sélection de la page hébergement parente</h4>
                        <br>
                        <v-select
                          v-model="rentingSelection"
                          :items="rentings"
                          outlined
                          chips
                          persistent-hint
                        ></v-select>

                        <br>

                        <h4>Sélection d'un marketing tag</h4>
                        <br>
                        <v-select
                          v-model="marketingTagSelection"
                          :items="marketingTags"
                          outlined
                          chips
                          multiple
                          persistent-hint
                        ></v-select>

                        <br>

                        <h4>Sélection d'une catégorie</h4>
                        <br>
                        <v-select
                          v-model="categorySelection"
                          :items="categories"
                          outlined
                          chips
                          persistent-hint
                        ></v-select>

                        <br>

                        <h4>Sélection d'un type d'hébergement</h4>
                        <br>
                        <v-select
                          v-model="rentingTypeSelection"
                          :items="rentingTypes"
                          outlined
                          chips
                          persistent-hint
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item>
                <v-card flat>
                  <v-card-text>
                    <ImageHandler
                      :key="generateUniqueId()"
                      :entity-data="entityData"
                      image-label="Photo principale"
                      image-name="mainImage"
                      :icons="icons"
                      :valid="valid"
                      :loading="loading"
                      :success-message="successMessage"
                      :snackbar="snackbar"
                      @update="updateEntityData($event)"
                    ></ImageHandler>

                    <br>

                    <v-divider class="v-divider-entity mt-5 mb-5"></v-divider>

                    <ImageHandler
                      :key="generateUniqueId()"
                      :entity-data="entityData"
                      image-label="Photo mobile"
                      image-name="mobileImage"
                      :icons="icons"
                      :valid="valid"
                      :loading="loading"
                      :success-message="successMessage"
                      :snackbar="snackbar"
                      @update="updateEntityData($event)"
                    ></ImageHandler>

                    <v-divider class="v-divider-entity mt-5 mb-5"></v-divider>

                    <h4>Texte bannière</h4>
                    <br>

                    <v-text-field
                      v-model="txtZone1[currentLocale]"
                      label="Texte zone 1"
                      class="mb-5"
                      outlined
                      dense
                      placeholder="Texte zone 1"
                      hide-details
                    >
                      <template v-slot:append>
                        <country-flag
                          class="inner-input-flag"
                          :country="currentLocale === 'en' ? 'gb' : currentLocale"
                          size="normal"
                          shadow
                        />
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="txtZone2[currentLocale]"
                      label="Texte zone 2"
                      class="mb-5"
                      outlined
                      dense
                      placeholder="Texte zone 2"
                      hide-details
                    >
                      <template v-slot:append>
                        <country-flag
                          class="inner-input-flag"
                          :country="currentLocale === 'en' ? 'gb' : currentLocale"
                          size="normal"
                          shadow
                        />
                      </template>
                    </v-text-field>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              class="mt-5 mr-2"
              color="primary"
              :disabled="!valid"
              type="submit"
            >
              Valider
            </v-btn>

            <v-btn
              class="mt-5"
              text
              :to="{ name: 'rentingList' }"
            >
              Retour
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from 'vue'
import { mdiEyeOutline, mdiEyeOffOutline, mdiCameraOutline, mdiMinusBox, mdiPencil, mdiCompassRose, mdiThumbUp, mdiSkiWater } from '@mdi/js'
import config from '../../config'
import LocalSwitcher from '@/components/Common/LocalSwitcher'
import Snackbar from '@/components/Common/Snackbar'
import Loader from '@/components/Common/Loader'
import ImageHandler from '@/components/Common/ImageHandler'
import router from '@/router'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import FullEditor from 'ckeditor5-custom-build/build/ckeditor'

export default {
  components: {
    ImageHandler,
    Snackbar,
    LocalSwitcher,
    Loader,
    ckeditor: CKEditor.component
  },
  data () {
    return {
      valid: false,
      errors: [],
      snackbar: false,
      successMessage: null,
      loading: false,
      currentLocale: 'fr',
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
        mdiCameraOutline,
        mdiMinusBox,
        mdiPencil,
        mdiCompassRose,
        mdiSkiWater,
        mdiThumbUp
      },
      editor: FullEditor,
      editorConfig: {
        toolbar: {
          shouldNotGroupWhenFull: true
        },
        heading: {
          options: [
            { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
            { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
            { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
            { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
            { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
            { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
            { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
          ]
        },
        htmlSupport: {
          allow: [
            {
              name: /.*/,
              attributes: true,
              classes: true,
              styles: true
            }
          ]
        },
        simpleUpload: {
          uploadUrl: config.apiUrl + '/api/medias',
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        }
      },
      rentings: [],
      rentingSelection: [],
      marketingTags: [],
      marketingTagSelection: [],
      categories: [],
      categorySelection: [],
      rentingTypes: [],
      rentingTypeSelection: [],
      name: [],
      slug: [],
      title: [],
      description: [],
      bottomDescription: [],
      seoTitle: [],
      seoDescription: [],
      seoKeywords: [],
      txtZone1: [],
      txtZone2: [],
      entityData: {
        enabled: true,
        inMenu: true,
        currentLocale: 'fr',
        defaultLocale: 'fr',
        newTranslations: {},
        mainImage: {
          id: null,
          title: null
        },
        mobileImage: {
          id: null,
          title: null
        }
      }
    }
  },
  created () {
    this.getRentings()
  },
  methods: {
    checkForm () {
      this.errors = []

      if (this.valid) {
        this.postRenting()
      }
    },
    apiUrl () {
      return config.apiUrl
    },
    getRentings () {
      this.loading = true

      const params = {
        limit: 150
      }

      Vue.prototype.$http
        .get(config.apiUrl + '/api/accommodation/rentings', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          },
          params: params
        })
        .then(response => {
          if (response.status === 200) {
            const rentings = response.data

            for (let i = 0; i < rentings.length; i++) {
              const currentRenting = rentings[i]
              
              let rentingName = 'Hébergement sans nom'
              
              if (currentRenting.name) {
                rentingName = currentRenting.name
              } else if (currentRenting.translations) {
                if (currentRenting.translations.en && currentRenting.translations.en.name) {
                  rentingName = currentRenting.translations.en.name
                } else if (currentRenting.translations.fr && currentRenting.translations.fr.name) {
                  rentingName = currentRenting.translations.fr.name
                }
              }

              this.rentings.push({
                text: rentingName,
                value: currentRenting.id
              })
            }
          }

          this.getMarketingTags()

        })
        .catch(error => {
          console.error('Erreur lors du chargement des hébergements:', error)
          this.loading = false
        })
    },
    getMarketingTags () {
      this.loading = true
      
      this.marketingTags = []

      const params = {
        limit: 150
      }

      Vue.prototype.$http
        .get(config.apiUrl + '/api/accommodation/marketing-tags', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          },
          params: params
        })
        .then(response => {
          if (response.status === 200) {
            const marketingTags = response.data

            for (let i = 0; i < marketingTags.length; i++) {
              const currentMarketingTag = marketingTags[i]
              
              let tagName = 'Tag sans nom'
              
              if (currentMarketingTag && 
                  currentMarketingTag.translations && 
                  currentMarketingTag.translations.en && 
                  currentMarketingTag.translations.en.name) {
                tagName = currentMarketingTag.translations.en.name
              } else {
                if (currentMarketingTag && 
                    currentMarketingTag.translations && 
                    currentMarketingTag.translations.fr && 
                    currentMarketingTag.translations.fr.name) {
                  tagName = currentMarketingTag.translations.fr.name
                }
              }

              this.marketingTags.push({
                text: tagName,
                value: currentMarketingTag.id
              })
            }
          }

          this.getCategories()

        })
        .catch(error => {
          console.error('Erreur lors du chargement des marketing tags:', error)
          this.loading = false
        })
    },
    getCategories () {
      this.loading = true

      const params = {
        limit: 150
      }

      Vue.prototype.$http
        .get(config.apiUrl + '/api/accommodation/categories', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          },
          params: params
        })
        .then(response => {
          if (response.status === 200) {
            const categories = response.data

            for (let i = 0; i < categories.length; i++) {
              const currentCategory = categories[i]
              
              let categoryName = 'Catégorie sans nom'
              
              if (currentCategory && 
                  currentCategory.translations && 
                  currentCategory.translations.en && 
                  currentCategory.translations.en.name) {
                categoryName = currentCategory.translations.en.name
              } else {
                if (currentCategory && 
                    currentCategory.translations && 
                    currentCategory.translations.fr && 
                    currentCategory.translations.fr.name) {
                  categoryName = currentCategory.translations.fr.name
                }
              }

              this.categories.push({
                text: categoryName,
                value: currentCategory.id
              })
            }
          }

          this.getRentingTypes()

        })
        .catch(error => {
          console.error('Erreur lors du chargement des catégories:', error)
          this.loading = false
        })
    },
    getRentingTypes () {
      this.loading = true

      const params = {
        limit: 150
      }

      Vue.prototype.$http
        .get(config.apiUrl + '/api/accommodation/types', {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          },
          params: params
        })
        .then(response => {
          if (response.status === 200) {
            const rentingTypes = response.data

            for (let i = 0; i < rentingTypes.length; i++) {
              const currentRentingType = rentingTypes[i]
              
              let typeName = 'Type sans nom'
              
              if (currentRentingType && 
                  currentRentingType.translations && 
                  currentRentingType.translations.en && 
                  currentRentingType.translations.en.name) {
                typeName = currentRentingType.translations.en.name
              } else {
                if (currentRentingType && 
                    currentRentingType.translations && 
                    currentRentingType.translations.fr && 
                    currentRentingType.translations.fr.name) {
                  typeName = currentRentingType.translations.fr.name
                }
              }

              this.rentingTypes.push({
                text: typeName,
                value: currentRentingType.id
              })
            }
          }

          this.loading = false

        })
        .catch(error => {
          console.error('Erreur lors du chargement des types d\'hébergement:', error)
          this.loading = false
        })
    },
    postRenting () {
      this.loading = true
      this.valid = false
      this.successMessage = null

      this.handleTranslations([
        'name',
        'slug',
        'title',
        'description',
        'bottomDescription',
        'seoTitle',
        'seoDescription',
        'seoKeywords',
        'txtZone1',
        'txtZone2'
      ])

      if (this.rentingSelection.length) {
        this.entityData.parent = {
          id: this.rentingSelection
        }
      }

      if (this.marketingTagSelection.length) {
        this.entityData.marketingTags = this.marketingTagSelection.map(id => {
          return { id: id }
        })
        
        if (this.marketingTagSelection.length === 1) {
          this.entityData.marketingTag = {
            id: this.marketingTagSelection[0]
          }
        } else {
          this.entityData.marketingTag = null
        }
      } else {
        this.entityData.marketingTags = []
        this.entityData.marketingTag = null
      }

      if (this.categorySelection.length) {
        this.entityData.category = {
          id: this.categorySelection
        }
      }

      if (this.rentingTypeSelection.length) {
        this.entityData.type = {
          id: this.rentingTypeSelection
        }
      }

      Vue.prototype.$http
        .post(config.apiUrl + '/api/accommodation/rentings', this.entityData, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.getToken
          }
        })
        .then(response => {
          if (response.status === 201) {
            this.renting = response.data

            this.errors = []
            this.snackbar = true
            this.successMessage = 'Page hébergement créée avec succès.'

            setTimeout(() => {
              router.push({ name: 'rentingDetails', params: { rentingId: this.renting.id } })
            }, 1500)
          }

          this.loading = false
        })
        .catch(e => {
          const response = e.response

          this.successMessage = null

          if (response.status === 400 || response.status === 404) {
            const data = response.data
            this.errors = data.violations
          }

          this.valid = true
          this.loading = false
        })
    },
    handleTranslations (attributes) {
      for (let i = 0; i < attributes.length; i++) {
        const currentAttribute = attributes[i]

        for (const [currentKey, currentValue] of Object.entries(this[currentAttribute])) {
          let translation = {
            locale: currentKey,
            empty: false
          }

          translation[currentAttribute] = currentValue

          const currentObjState = this.entityData.newTranslations[currentKey]

          this.entityData.newTranslations[currentKey] = {...currentObjState, ...translation}
        }
      }
    },
    updateCurrentLocale (locale) {
      this.currentLocale = locale
      this.successMessage = null
    },
    updateEntityData (updatedData) {
      this.entityData = updatedData
    },
    updateLoading (loading) {
      this.loading = loading
    },
    updateSnackbar (snackbar) {
      this.snackbar = snackbar
    },
    updateSuccessMessage (successMessage) {
      this.successMessage = successMessage
    },
    updateValid (valid) {
      this.valid = valid
    }
  }
}
</script>

